import React from "react";
import { useTranslation } from "react-i18next";

import cn from "clsx";
import { RiskKycPresetRule } from "store/risk/kyc/presets/slice";
import MainPageSortItem from "pages/CMS/Widgets/components/MainPageSortItem";
import RoundBtn from "components/buttons/RoundBtn";
import { RiskKycRulesItem } from "store/risk/kyc/rules/slice";
import styles from "./RiskKycPresetTab.module.scss";

type Props = {
  assignedRules: RiskKycPresetRule[];
  unassignedRules: RiskKycRulesItem[];
  selectedToUnassignRules: RiskKycPresetRule["id"][];
  selectedToAssignRules: RiskKycRulesItem["id"][];
  onSelectAssignedRules: (v: RiskKycPresetRule["id"]) => void;
  onSelectUnassignedRules: (v: RiskKycRulesItem["id"]) => void;
  onAssignRules: () => void;
  onUnassignRules: () => void;
  readOnly?: boolean;
}


const RiskKycPresetRulesTab: React.FC<Props> = ({
  assignedRules,
  unassignedRules,
  selectedToUnassignRules,
  selectedToAssignRules,
  onSelectAssignedRules,
  onSelectUnassignedRules,
  onAssignRules,
  onUnassignRules,
  readOnly
}) => {
  const { t } = useTranslation();
  
  return (
    <div className={cn("main-page-content", styles.rules)}>
      <div className="main-page-widget">
        <div className="main-page-widget--box">
          <div className="main-page-title">{t("selectedRules")}</div>
          <div className="main-page-widget--list">
            {assignedRules.map((el, index) => (
              <MainPageSortItem
                key={el.id}
                item={{
                  ...el,
                  label: `${el.rule.type} ${el.rule.amount} ${el.rule.currency}`
                }}
                hideImage
                index={index}
                moveItem={() => { }}
                isSelected={selectedToUnassignRules.includes(el.id)}
                handleClick={() => onSelectAssignedRules(el.id)}
                isBurger
                customContent={null}
                isDraggable={!readOnly}
              />
            ))}
          </div>

    
        </div>
      </div>
      {!readOnly && (
        <div className="main-page-btns">
          <RoundBtn
            txt="+"
            disabled={!selectedToAssignRules.length}
            handleClick={onAssignRules}
          />
          <RoundBtn
            txt="-"
            disabled={!selectedToUnassignRules.length}
            handleClick={onUnassignRules}
          />
        </div>
      )}
      <div className="main-page-widget">
        <div className="main-page-widget--box">
          <div className="main-page-title">{t("availableRules")}</div>
          <div className="main-page-widget--list">
            {unassignedRules.map((el, index) => (
              <MainPageSortItem
                key={el.id}
                item={{
                  ...el,
                  label: `${el.type} ${el.amount} ${el.currency}`
                }}
                hideImage
                index={index}
                moveItem={() => { }}
                isSelected={selectedToAssignRules.includes(el.id)}
                handleClick={() => onSelectUnassignedRules(el.id)}
                isBurger
                isDraggable={!readOnly}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RiskKycPresetRulesTab;
